import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export interface DenominationsList {
    country_id: number;
    denominations: number[];
}

export function denominationsList(
    state: DenominationsList = {
        country_id: 0,
        denominations: []
    },
    action: Action
) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_DENOMINATIONS:
            return Object.assign({}, state, {
                country_id: action.payload.countryId
            });
        case ConfigurationsActionTypes.GET_DENOMINATIONS_SUCCESS:
            let response = action.payload.results[0];
            action.payload.results.forEach(item => {
                if (item.country_id === state.country_id) response = item;
            });

            return Object.assign({}, state, {
                denominations: response.denominations
            });
        default:
            return state;
    }
}
